<template lang="pug">
    Checkbox(
            :value="value" 
            @on-change="onChange"
            :true-value="formItem.trueValue"
            :false-value="formItem.falseValue")
</template>
<script>
export default {
    props: ["formItem", "formData", "value"],
    watch: {},
    methods: {
        onChange(val) {
            this.$emit("input", val);
            if (typeof this.formItem.watchField == "function") this.formItem.watchField(value, this.formData);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/Checkbox.vue